export default __webpack_public_path__ + "static/pattern-warm-b3e8c6f799e4bf5021eb20fe4fb3ba56.jpg";